import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { DisplayModelDto } from '../../models/display/display-model.dto';
import { SavedDatabaseModel } from '../../models/saved/saved-database-model.type';

@Injectable({
  providedIn: 'root',
})
export class DisplayModelApiService {
  private _http: HttpClient = inject(HttpClient);

  private readonly _BASE_API_URL = environment.apiUrl;

  public post$(databaseModel: SavedDatabaseModel): Observable<DisplayModelDto> {
    return this._http.post<DisplayModelDto>(this._BASE_API_URL + `/display/model`, databaseModel);
  }
}
